'use client'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { useTranslations } from 'next-intl'
import { usePricesForUser } from '@repo/cf-user/hooks/use-prices'

import { LFS_URL } from '@web/utils/env'
import { PartnerRatingCard } from '@web/app/[locale]/(studio)/studio/partners/_components/partner-rating-card'

export function RatingItem() {
  const t = useTranslations('pages.studio_partners')
  const { prices, currency } = usePricesForUser()

  return (
    <PartnerRatingCard
      className="shrink-0 grow-0 basis-1/2"
      image={{
        src: `${LFS_URL}/web/pages/siser/CF_horizontal-logo_512px.png`,
        alt: 'Siser',
        width: 300,
        height: 70,
      }}
      name={t('siser.rating.items.1.name')}
      copy={t('siser.rating.items.1.copy', {
        currency: currency.symbol,
        yearlyPromo: prices.yearlyPromo,
      })}
      starsNb={5}
      reviews={t('siser.rating.items.1.reviews')}
      cta={{
        text: t('siser.rating.items.1.cta', {
          currency: currency.symbol,
          yearlyPromo: prices.yearlyPromo,
        }),
        href: AppRoutes.HOME,
        target: '_blank',
      }}
    />
  )
}
